const DEFAULT_EMPTY_PLACEHOLDER = "—";

export function isCopyableValue(value, { emptyPlaceholder = DEFAULT_EMPTY_PLACEHOLDER } = {}) {
  if (value == null) return false;

  const text = String(value).trim();
  return Boolean(text) && text !== emptyPlaceholder;
}

export async function copyTextToClipboard(text) {
  try {
    await navigator.clipboard.writeText(String(text).trim());
    return { ok: true };
  } catch (error) {
    return { ok: false, error };
  }
}

export function buildLabeledText(entries, { emptyPlaceholder = DEFAULT_EMPTY_PLACEHOLDER } = {}) {
  return entries
    .filter(({ value }) => isCopyableValue(value, { emptyPlaceholder }))
    .map(({ label, value }) => `${label}: ${value}`)
    .join("\n");
}
